import {NotifyCustomerRestService} from './restServices';
import storageService from '../storageService';

var service = {};

service.sendMessageByEmail = async (requestObj, token) => {
  let reqObj = {
    ...requestObj,
    token: token ? token : storageService.getItem('token'),
  };
  const response = await NotifyCustomerRestService.save(
    {
      endpoint: '',
    },
    reqObj,
  );
  return response.data;
};

const notifyCustomerService = {...service};
export default notifyCustomerService;
